import script from "./doctor.vue?vue&type=script&setup=true&lang=js"
export * from "./doctor.vue?vue&type=script&setup=true&lang=js"

import "./doctor.vue?vue&type=style&index=0&id=dd062ff4&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd062ff4"]])

export default __exports__